<template>
	<v-row class="ma-1">
		<v-col cols="6">
			<dactyl-tree
				:sde-uuid="localSdeUuid"
				:data-point-uuid="localDataPointUuid"
				@select:node="selectNode"
			></dactyl-tree>
		</v-col>
		<v-col cols="6">
			<pdf-viewer
				ref="pdfViewer"
				:paper-uuid="localPaperUuid"
				:sde-uuid="localSdeUuid"
				:data-point-uuid="localDataPointUuid"
				:selected-node="selectedNode"
			></pdf-viewer>
		</v-col>
	</v-row>
</template>

<script>
import DactylTree from "@/pages/DataViewer/DactylTree.vue";
import PdfViewer from "@/pages/DataViewer/PdfViewer.vue";

import { mapActions } from "pinia";
import { useMainStore } from "@/store";
import _ from "lodash";

export default {
	name: "DataViewer",
	components: {
		DactylTree,
		PdfViewer,
	},

	props: {
		paperUuid: {
			type: String,
			default: "",
		},
		sdeUuid: {
			type: String,
			default: "",
		},
		dataPointUuid: {
			type: String,
			default: "",
		},
	},

	data() {
		return {
			selectedNode: null,
			localPaperUuid: this.paperUuid,
			localSdeUuid: this.sdeUuid,
			localDataPointUuid: this.dataPointUuid,
		};
	},

	watch: {
		paperUuid(val) {
			this.localPaperUuid = val;
		},
		sdeUuid(val) {
			this.localSdeUuid = val;
		},
		dataPointUuid(val) {
			this.localDataPointUuid = val;
		},
	},

	created() {
		if (!this.paperUuid && !this.sdeUuid) {
			console.error("DataViewer requires either paperUuid or sdeUuid.");
		}
	},

	mounted() {
		window.addEventListener("message", this.handleMessage);
	},

	beforeUnmount() {
		window.removeEventListener("message", this.handleMessage);
	},

	methods: {
		...mapActions(useMainStore, ["showNotification"]),
		handleMessage(event) {
			const data = event.data;
			if (data && typeof data === "object") {
				if (data.type === "UPDATE_CONTEXT") {
					this.localSdeUuid = data.sdeUuid;
					this.localDataPointUuid = data.dataPointUuid;
					this.$router.replace({
						query: {
							...this.$route.query,
							sdeUuid: this.localSdeUuid,
							dataPointUuid: this.localDataPointUuid || undefined,
						},
					});
				}
			}
		},
		selectNode(node) {
			if (_.isEmpty(node)) {
				this.selectedNode = null;
			} else {
				this.selectedNode = { ...node, __selectionNonce: Date.now() };
			}
		},
	},
};
</script>

<style scoped lang="scss"></style>
